import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import VamosPadel from "../assets/images/VamosClub.png";
import PadelFactory from "../assets/images/padelfactory.png";
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (id) => {
    const handleScroll = () => {
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    };

    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(handleScroll, 300); // Add a delay to ensure navigation completes
    } else {
      handleScroll();
    }
  };

  return (
    <div className="container">
      <nav className="navbar d-flex justify-content-center">
        <Link className="navbar-brand" to="/">
          <img
            className="logo-color"
            src="https://playpro.pk/images/logo.png"
            alt="image"
          />
          {/* <img
            className="logo-white"
            src="https://playpro.pk/images/playprologowhite.png"
            alt="image"
          /> */}
        </Link>
        <Link className="navbar-brand" to="/">
          <img
            className="logo-color"
            src={PadelFactory}
            alt="image"
            style={{
              height: 60,
            }}
          />
          <img
            className="logo-white"
            src="https://playpro.pk/images/playprologowhite.png"
            alt="image"
          />
        </Link>
        {/* <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon">
            <div className="toggle-wrap">
              <span className="toggle-bar"></span>
            </div>
          </span>
        </button>

        <div
          className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}
          id="navbarSupportedContent"
        >
           <ul className="navbar-nav ml-auto">
            <li className="nav-item has_dropdown">
              <Link className="nav-link" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item has_dropdown">
              <a className="nav-link" onClick={() => scrollToSection('about')}>
                About
              </a>
            </li>
            <li className="nav-item has_dropdown">
              <a className="nav-link" onClick={() => scrollToSection('features')}>
                Features
              </a>
            </li>
            <li className="nav-item has_dropdown">
              <a
                className="nav-link"
                onClick={() => scrollToSection('how_it_work')}
              >
                How it works
              </a>
            </li>
            <li className="nav-item has_dropdown">
              <Link className="nav-link" to="#">
                Availability
              </Link>
              <span className="drp_btn">
                <i className="icofont-rounded-down"></i>
              </span>
              <div className="sub_menu">
                <ul>
                  <li>
                    <Link to="/court-availability/club-padel">
                      Club Padel Lahore
                    </Link>
                  </li>
                  <li>
                    <Link to="/court-availability/champions-club">
                      Champions Club
                    </Link>
                  </li>
                  <li>
                    <Link to="/court-availability/vamos-padel-club">
                      Vamos Padel Club Karachi
                    </Link>
                  </li>
                  <li>
                    <Link to="/court-availability/padel-factory">
                      Padel Factory Karachi
                    </Link>
                  </li>
                  <li>
                    <Link to="/court-availability/padel-edge">
                      Padel Edge Multan
                    </Link>
                  </li>
                  <li>
                    <Link to="/court-availability/padel-pro">
                      Padel Pro Lahore
                    </Link>
                  </li>
                  <li>
                    <Link to="/court-availability/arena-360">
                      Arena 360 Lahore
                    </Link>
                  </li>
                  <li>
                    <Link to="/court-availability/padel-star">
                      Padel Star Lahore
                    </Link>
                  </li>
                  <li>
                    <Link to="/availability">View All Clubs</Link>
                  </li>
                </ul>
              </div>
            </li>
            <li className="nav-item has_dropdown">
              <Link className="nav-link" to="/court-booking-system">
                Court booking system
              </Link>
            </li>
            <li className="nav-item has_dropdown">
              <Link className="nav-link" to="/contact-us">
                Contact
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link dark_btn" to="/contact-us">
                GET STARTED
              </Link>
            </li>
          </ul> 
        </div> */}
      </nav>
    </div>
  );
};

export default Header;
